export default __webpack_public_path__ + "static/media/group-3-mobile-img1.3681343f.png";